import { ITheme, IStyle, mergeStyleSets, getTheme, Icon } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../../app-core/app-theme';
import { formatString } from '../../../framework/utils/string';

interface IMeaurementRequestNoteProps {
  requestDate: Date;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '0.6rem',
    display: 'flex',
    alignItems: 'stretch',
    border: '1px solid white',
    borderLeft: 'none',
    borderRight: 'none',
    backgroundColor: BwjPalette.themeInfoBackground,
    borderColor: BwjPalette.themeInfo,
    color: BwjPalette.themeInfo,

    '& > p': {
      fontSize: theme.fonts.small.fontSize,
      lineHeight: theme.fonts.smallPlus.lineHeight,
      margin: 0,
      padding: 0,
      marginLeft: '0.25rem',
      flexGrow: 1,
    },
  };

  const iconContainer: IStyle = {
    theme: 0,
    padding: 0,
    paddingRight: '0.25rem',

    '& > i': {
      fontSize: theme.fonts.large.fontSize,
    },
  }

  return mergeStyleSets({
    root,
    iconContainer,
  });
}

export const MeaurementRequestNote: React.FunctionComponent<IMeaurementRequestNoteProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { requestDate } = props;
  const date = formatString('{d:d-MMMdyyyy}', {d: requestDate });

  return (
    <div className={cs.root}>
      <div className={cs.iconContainer}>
        <Icon
          iconName={'Info'}
          aria-hidden={true}
        />
      </div>
      <p>You requested measurement &amp; pricing info <strong>{date.success ? date.formattedString : ''}</strong></p>
    </div>
  );
};
